import { api } from "@/lib/api";

// Catch the browser's install offer early (it can fire before React mounts).
let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(deferred));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  let last = 0;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && Date.now() - last > 5 * 60 * 1000 && window.__snaplistReport) { last = Date.now(); window.__snaplistReport(); }
  });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.setItem("snaplist.pcInstalled", "1"); emit(); reportDevice(true); });
}

export const getInstallPrompt = () => deferred;
export const onInstallPrompt = (f) => { subs.add(f); return () => subs.delete(f); };

export async function runInstall() {
  if (!deferred) return "unavailable";
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  if (outcome === "accepted") { deferred = null; emit(); }
  return outcome;
}

// Tell the owner's Team page whether this phone / PC has SnapList installed and alerts allowed.
export function reportDevice(installed) {
  const alerts = typeof Notification !== "undefined" && Notification.permission === "granted";
  api.post("/push/device", { kind: isDesktop() ? "pc" : "phone", installed: !!installed || isStandalone(), alerts }).catch(() => {});
}

export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isDesktop = () => !window.matchMedia?.("(pointer: coarse)").matches && window.innerWidth >= 900;

export function desktopBrowser() {
  const ua = navigator.userAgent;
  if (/Edg\//.test(ua)) return "edge";
  if (/Chrome\//.test(ua) && !/OPR\//.test(ua)) return "chrome";
  if (/Macintosh/.test(ua) && /Safari\//.test(ua) && !/Chrome|Chromium|Firefox/.test(ua)) return "safari";
  return "other";
}
